import React from 'react'

function ArrowRight2Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M9 6L9.35355 5.64645L9.70711 6L9.35355 6.35355L9 6ZM3 6.5C2.72386 6.5 2.5 6.27614 2.5 6C2.5 5.72386 2.72386 5.5 3 5.5V6.5ZM7.35355 3.64645L9.35355 5.64645L8.64645 6.35355L6.64645 4.35355L7.35355 3.64645ZM9.35355 6.35355L7.35355 8.35355L6.64645 7.64645L8.64645 5.64645L9.35355 6.35355ZM9 6.5H3V5.5H9V6.5Z"
        fill="#65677D"
      />
    </svg>
  )
}

export default ArrowRight2Icon
